import { Fragment } from 'react'
import { AboutLLC } from './AboutLLC'

interface IAboutLLCTabProps {
  activeTab?: string
}

const AboutLLCTab = ({ activeTab }: IAboutLLCTabProps) => {
  return (
    <Fragment>
      <div className="bg-white p-5 pt-[60px]">
        <div>
          <>
            <AboutLLC activeTab={activeTab} />
          </>
        </div>
      </div>
    </Fragment>
  )
}

export default AboutLLCTab
